import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableInvalidPhone = loadable(() => import('./InvalidPhone'), {
  fallback: <LoadingScreen />,
});

export default LoadableInvalidPhone;
